var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"llm-skeleton-tips d-flex",staticStyle:{"padding":"1rem 0"}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n    "),_vm._m(0)]),_c('el-skeleton',{attrs:{"rows":10,"animated":""}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"dot"}),_c('div',{staticClass:"dot"}),_c('div',{staticClass:"dot"})])
}]

export { render, staticRenderFns }